import React from 'react';

function Datenschutz() {
  return (
    <main id="main-content" role="main">
      {/* Hero Section */}
      <section className="hero hero--small">
        <div className="container">
          <div className="hero__content">
            <div className="hero__text">
              <h1 className="hero__title">Datenschutzerklärung</h1>
              <p className="hero__subtitle">
                Informationen zur Verarbeitung Ihrer personenbezogenen Daten
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Privacy Content */}
      <section className="legal-content">
        <div className="container">
          <div className="legal-wrapper">
            <div className="legal-section">
              <h2>1. Datenschutz auf einen Blick</h2>
              <h3>Allgemeine Hinweise</h3>
              <p>
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
                personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene
                Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
              </p>

              <h3>Datenerfassung auf dieser Website</h3>
              <p>
                <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber.
              </p>
              <p>
                <strong>Wie erfassen wir Ihre Daten?</strong><br />
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Andere Daten
                werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst.
              </p>
              <p>
                <strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong><br />
                Sie haben jederzeit das Recht auf unentgeltliche Auskunft, Berichtigung oder Löschung
                Ihrer gespeicherten personenbezogenen Daten.
              </p>
            </div>

            <div className="legal-section">
              <h2>2. Hosting und Content Delivery Networks (CDN)</h2>
              <h3>Externes Hosting</h3>
              <p>
                Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website
                erfasst werden, werden auf den Servern des Hosters gespeichert.
              </p>
            </div>

            <div className="legal-section">
              <h2>3. Allgemeine Hinweise und Pflichtinformationen</h2>
              <h3>Datenschutz</h3>
              <p>
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir
                behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen
                Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>

              <h3>Hinweis zur verantwortlichen Stelle</h3>
              <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
              <address>
                track by track GmbH<br />
                Schliemannstraße 23<br />
                10437 Berlin<br />
                Deutschland
              </address>
              <p>
                <strong>Telefon:</strong> <a href="tel:+4930403665430">030 403 665 430</a><br />
                <strong>E-Mail:</strong> <a href="mailto:info@famefact.com">info@famefact.com</a>
              </p>
            </div>

            <div className="legal-section">
              <h2>4. Datenerfassung auf dieser Website</h2>
              <h3>Cookies</h3>
              <p>
                Diese Website verwendet technisch notwendige Cookies, um die Funktionalität der Website
                sicherzustellen.
              </p>

              <h3>Kontaktformulare</h3>
              <p>
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben zwecks
                Bearbeitung der Anfrage bei uns gespeichert.
              </p>

              <h3>Server-Log-Dateien</h3>
              <p>Der Provider der Seiten erhebt und speichert automatisch Informationen wie:</p>
              <ul>
                <li>Browsertyp und Browserversion</li>
                <li>verwendetes Betriebssystem</li>
                <li>Referrer URL</li>
                <li>Hostname des zugreifenden Rechners</li>
                <li>Uhrzeit der Serveranfrage</li>
                <li>IP-Adresse</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>5. Analyse-Tools und Werbung</h2>
              <h3>Google Tag Manager</h3>
              <p>
                Wir setzen den Google Tag Manager ein. Anbieter ist die Google Ireland Limited, Gordon House, 
                Barrow Street, Dublin 4, Irland.
              </p>

              <h3>Google Analytics</h3>
              <p>
                Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics zur Analyse des 
                Nutzerverhaltens.
              </p>

              <h3>IP-Anonymisierung</h3>
              <p>
                Die Google Analytics IP-Anonymisierung ist aktiviert. Dadurch wird Ihre IP-Adresse von Google 
                gekürzt.
              </p>

              <h3>Meta-Pixel (ehemals Facebook Pixel)</h3>
              <p>
                Diese Website nutzt zur Konversionsmessung der Besucheraktions-Pixel von Facebook/Meta.
              </p>

              <h3>LinkedIn Insight Tag</h3>
              <p>
                Diese Website nutzt das Insight-Tag von LinkedIn zur besseren Zielgruppenansprache.
              </p>
            </div>

            <div className="legal-section">
              <h2>6. Soziale Medien</h2>
              <h3>Social-Media-Elemente</h3>
              <p>
                Auf dieser Website werden Elemente von sozialen Medien verwendet (z. B. Facebook, Instagram, 
                LinkedIn, TikTok).
              </p>

              <h3>Facebook</h3>
              <p>
                Auf dieser Website sind Elemente des sozialen Netzwerks Facebook integriert. Anbieter ist die 
                Meta Platforms Ireland Limited.
              </p>

              <h3>Instagram</h3>
              <p>
                Auf dieser Website sind Funktionen des Dienstes Instagram eingebunden.
              </p>

              <h3>LinkedIn</h3>
              <p>
                Diese Website nutzt Elemente des Netzwerks LinkedIn.
              </p>
            </div>

            <div className="legal-section">
              <h2>7. Newsletter</h2>
              <p>
                Wenn Sie den Newsletter beziehen möchten, benötigen wir von Ihnen eine E-Mail-Adresse sowie
                Informationen zur Verifizierung.
              </p>
            </div>

            <div className="legal-section">
              <h2>8. Plugins und Tools</h2>
              <h3>YouTube mit erweitertem Datenschutz</h3>
              <p>
                Diese Website bindet Videos der Website YouTube ein im erweiterten Datenschutzmodus.
              </p>

              <h3>Google Fonts (lokales Hosting)</h3>
              <p>
                Diese Seite nutzt Google Fonts, die lokal installiert sind. Eine Verbindung zu Google-Servern 
                findet nicht statt.
              </p>

              <h3>Google Maps</h3>
              <p>
                Diese Seite nutzt den Kartendienst Google Maps zur Darstellung unseres Standorts.
              </p>
            </div>

            <div className="legal-section">
              <h2>9. Eigene Dienste</h2>
              <h3>Umgang mit Bewerberdaten</h3>
              <p>
                Wir bieten Ihnen die Möglichkeit, sich bei uns zu bewerben. Wir verarbeiten Ihre Bewerbungsdaten
                zur Entscheidung über die Begründung eines Beschäftigungsverhältnisses.
              </p>

              <h4>Aufbewahrungsdauer der Daten</h4>
              <p>
                Sofern wir Ihnen kein Stellenangebot machen können, behalten wir Ihre Daten bis zu 6 Monate 
                nach Beendigung des Bewerbungsverfahrens auf.
              </p>
            </div>

            <div className="legal-section">
              <h2>10. Ihre Rechte</h2>
              <h3>Recht auf Auskunft (Art. 15 DSGVO)</h3>
              <p>
                Sie haben das Recht, Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu
                verlangen.
              </p>

              <h3>Recht auf Berichtigung (Art. 16 DSGVO)</h3>
              <p>
                Sie haben das Recht, die Berichtigung unrichtiger oder Vervollständigung Ihrer Daten zu
                verlangen.
              </p>

              <h3>Recht auf Löschung (Art. 17 DSGVO)</h3>
              <p>
                Sie haben das Recht, die Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu
                verlangen.
              </p>

              <h3>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</h3>
              <p>
                Sie haben das Recht, Ihre Daten in einem strukturierten, gängigen Format zu erhalten.
              </p>

              <h3>Widerspruchsrecht (Art. 21 DSGVO)</h3>
              <p>
                Sie haben das Recht, Widerspruch gegen die Verarbeitung Ihrer personenbezogenen Daten
                einzulegen.
              </p>
            </div>

            <div className="legal-section">
              <h2>11. Widerspruch gegen Werbe-Mails</h2>
              <p>
                Der Nutzung von Kontaktdaten zur Übersendung nicht ausdrücklich angeforderter Werbung wird
                hiermit widersprochen.
              </p>
            </div>

            <div className="legal-section">
              <h2>12. Aktualisierung dieser Datenschutzerklärung</h2>
              <p>
                Diese Datenschutzerklärung wird regelmäßig überprüft und bei Bedarf aktualisiert.
              </p>
              <p>
                <strong>Stand: 15. Januar 2025</strong>
              </p>
            </div>

            <div className="legal-section">
              <h2>13. Kontakt für Datenschutzfragen</h2>
              <p>Bei Fragen zum Datenschutz können Sie sich jederzeit an uns wenden:</p>
              <address>
                track by track GmbH<br />
                Datenschutzbeauftragter<br />
                Schliemannstraße 23<br />
                10437 Berlin<br />
                Deutschland
              </address>
              <p>
                <strong>E-Mail:</strong> <a href="mailto:datenschutz@famefact.com">datenschutz@famefact.com</a><br />
                <strong>Telefon:</strong> <a href="tel:+4930403665430">030 403 665 430</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Datenschutz;
